import { MapPin, Phone, User } from 'lucide-react';
import { LocationType } from '@/types/location';

export const isConfrenceType = (type: LocationType) => {
  return [
    LocationType.google_meet,
    LocationType.zoom,
    LocationType.zoho,
    LocationType.microsoft_teams,
    LocationType.goto_meeting,
    LocationType.webex,
    LocationType.joinme,
  ].includes(type);
};

export const getLocationIcon = (type: LocationType) => {
  switch (type) {
    case LocationType.google_meet:
    case LocationType.zoom:
    case LocationType.zoho:
    case LocationType.microsoft_teams:
    case LocationType.goto_meeting:
    case LocationType.webex:
    case LocationType.joinme:
    case LocationType.virtual:
      return (
        <img
          src={'https://cdn.dayschedule.com/icon/' + type + '.png'}
          width={20}
          height={20}
          alt={type}
        />
      );

    case LocationType.physical:
      return <MapPin className="w-5 h-5 text-muted-foreground" />;

    case LocationType.phone:
    case LocationType.inbound_call:
      return <Phone className="w-5 h-5 text-muted-foreground" />;

    case LocationType.ask_invitee:
      return <User className="w-5 h-5 text-muted-foreground" />;

    default:
      return <MapPin className="w-5 h-5 text-muted-foreground" />;
  }
};
